module.exports = __webpack_public_path__ + "static/media/osu-web-header-horiz.222826ba.png";